module.exports = __webpack_public_path__ + "static/media/logo.72e6be01.png";